export default "__VITE_ASSET__Cv2e8u9N__"